module.exports = __webpack_public_path__ + "img/alipay.d12289dd.png";